import * as React from "react"

export default function AdventureIcon(props) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29 24.6934L20 28.0684L12 25.0684L3 28.4434V7.30664L12 3.93164L20 6.93164L29 3.55664V24.6934ZM5 8.69336V25.5566L12 22.9316L20 25.9316L27 23.3066V6.44336L20 9.06836L12 6.06836L5 8.69336ZM24.707 13.707L22.4141 16L24.707 18.293L23.293 19.707L21 17.4141L18.707 19.707L17.293 18.293L19.5859 16L17.293 13.707L18.707 12.293L21 14.5859L23.293 12.293L24.707 13.707ZM11 17H9V15H11V17ZM16 15V17H14V15H16Z"
        fill={props.fill}
      />
    </svg>
  )
}